module.exports = __webpack_public_path__ + "img/background_Image.2da98eb9.png";